import { useCallback, useEffect, useRef, useState } from "react"
import { useLocation, Outlet } from "react-router-dom"
import { useAmplitudeUser } from "~/common/useAmplitudeUser"
import { useServerAnalyticsEvent } from "~/common/useServerAnalyticsEvent"
import { DocumentTitleTrackingProvider } from "~/common/useDocumentTitle"
import { trackEvent } from "~/util/tracking"

export const AnalyticsTracking = () => {
  const location = useLocation()
  const [resolvedPage, setResolvedPage] = useState<{
    location: typeof location
    title: string
  }>()
  const trackedLocation = useRef<typeof location>()

  useAmplitudeUser()
  useServerAnalyticsEvent()

  const onTitleReady = useCallback(
    (title: string) => {
      setResolvedPage({ location, title })
    },
    [location]
  )

  useEffect(() => {
    if (
      resolvedPage?.location !== location ||
      trackedLocation.current === location
    )
      return

    trackEvent("page_view", {
      page_location: location.pathname + location.search + location.hash,
      page_title: resolvedPage.title,
    })
    trackedLocation.current = location
  }, [location, resolvedPage])

  return (
    <DocumentTitleTrackingProvider onTitleReady={onTitleReady}>
      <Outlet />
    </DocumentTitleTrackingProvider>
  )
}
